import React, { useContext, useState, useEffect  } from "react";
import { Box, Grid, TextField, Avatar, IconButton, Button, Typography, Card, useTheme } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import GradientButton from "../components/Button"
import { AuthContext } from "../theme/AuthContext";
import { userProfile } from "../api/authAPI";
import { getUserProfile } from "../api/authAPI";

export default function UserProfile() {
  const theme = useTheme();
  const { user, updateProfilePic } = useContext(AuthContext);

  const [profileImage, setProfileImage] = useState(null); 
  const [profileFile, setProfileFile] = useState(null);   
  const [aadharFile, setAadharFile] = useState(null);

  const [formData, setFormData] = useState({
  userId: user?.username || "",
  email: user?.email || "",
  name: "",
  fatherName: "",
  motherName: "",
  qualification: "",
  aadharNo: "",
});

  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await getUserProfile(user?.email);

      if (res.success) {
        const data = res.data;
        console.log("PROFILE PIC URL:", data.profilePic);
        setFormData({
          userId: user?.username || "",
          email: data.email || "",
          name: data.name || "",
          fatherName: data.fatherName || "",
          motherName: data.motherName || "",
          qualification: data.qualification || "",
          aadharNo: data.aadharNo || "",
        });

        // Profile image show
        if (data.profilePic) {
          setProfileImage(data.profilePic);
          updateProfilePic(data.profilePic);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (user?.email) {
    fetchProfile();
  }
}, [user]);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

   const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleAadharUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAadharFile(file);
    }
  };

  const handleSave = async () => {
  try {
    const formDataToSend = new FormData();

    // TEXT FIELDS
    formDataToSend.append("userId", formData.userId);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("fatherName", formData.fatherName);
    formDataToSend.append("motherName", formData.motherName);
    formDataToSend.append("qualification", formData.qualification);
    formDataToSend.append("aadharNo", formData.aadharNo);

    // FILES
    if (profileFile) {
      formDataToSend.append("profilePic", profileFile);
    }

    if (aadharFile) {
      formDataToSend.append("aadharFile", aadharFile);
    }

    const res = await userProfile(formDataToSend);

    const newProfilePic = res.data?.data?.Attributes?.profilePic;

    if (newProfilePic) {
      setProfileImage(newProfilePic);
      updateProfilePic(newProfilePic);
    }

    alert("Profile updated successfully");
  } catch (error) {
    console.error(error);
    alert("Failed to update profile");
  }
};




  

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", display: "flex", justifyContent: "center", p: 4, bgcolor: theme.palette.background.default }}>
      <Card sx={{ width: "100%",p:3, borderRadius: 2, boxShadow: 2, backgroundColor: theme.palette.background.paper }}>
        {/* Profile Image */}
        <Box display="flex" flexDirection="column" alignItems="center" mb={6}>
          <Box sx={{ position: "relative" }}>
            <Avatar
              src={profileImage || "/placeholder-profile.jpg"}
              sx={{ width: 100, height: 100, border: `3px solid ${theme.palette.divider}` }}
            />
            <IconButton
              component="label"
              sx={{
                position: "absolute",
                bottom: 0,
                right: 0,
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                width: 40,
                height: 40,
                ":hover": { bgcolor: theme.palette.primary.dark },
              }}
            >
              <UploadIcon />
              <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
            </IconButton>
          </Box>
        </Box>

        {/* Form Fields */}
        <Grid container spacing={3}>
          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Display Name</Typography>
            <TextField fullWidth name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" />
          </Grid>

          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Email</Typography>
            <TextField fullWidth name="email" value={formData.email} onChange={handleChange} placeholder="Enter email address"  disabled/>
          </Grid>

          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Father's Name</Typography>
            <TextField fullWidth name="fatherName" value={formData.fatherName} onChange={handleChange} placeholder="Father's Name" />
          </Grid>

          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Mother's Name</Typography>
            <TextField fullWidth name="motherName" value={formData.motherName} onChange={handleChange} placeholder="Mother's Name" />
          </Grid>

          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Qualification</Typography>
            <TextField fullWidth name="qualification" value={formData.qualification} onChange={handleChange} placeholder="Qualification" />
          </Grid>

          <Grid size={{xs:12,md:6}}>
            <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Aadhar Card Number</Typography>
            <TextField fullWidth name="aadharNo" value={formData.aadharNo} onChange={handleChange} placeholder="xxxxxxxxxxxx" />
          </Grid>
        </Grid>

        {/* Aadhar Upload */}
        <Box mt={4}>
          <Typography fontSize={14} fontWeight={400} color={theme.palette.text.secondary} mb={1}>Upload Aadhar Card (jpg/jpeg only)</Typography>
          <Button
            variant="outlined"

            component="label"
            startIcon={<UploadIcon />}
            sx={{ textTransform: "none", p: 1.4 }}
          >
            Upload Here
            <input hidden type="file" accept="image/jpeg,image/jpg" onChange={handleAadharUpload} />
          </Button>
        </Box>

        {/* Save */}
        <Box display="flex" justifyContent="center" mt={6}>
          <GradientButton onClick={handleSave}>
            Save
          </GradientButton>
        </Box>
      </Card>
    </Box>
  );
}
